import {useTranslation} from "react-i18next";
import React from "react";
import {TotalAccessApp} from "../Funtionality/TotalAccessApp";
import DividerWithText from "../../../../components/DividerWithText";
import SubZonesDetailsTable from "./SubZonesDetailsTable";
import Subtitle from "../../../../components/Header/Subtitle";
import CustomTable from "../../../../components/table/CustomTable";
import DeleteModal from "../../../Modals/DeleteModal";
import DeviceLogModal from "../../Devices/Modals/DeviceLogModal";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const RenderExpandedRow = ({row}) => {
    const {t} = useTranslation();
    const { tableId,
        dispatch,
        searchId,
        thead,
        tbody,
        deleteSelectedDevices,
        selectDeviceForDelete,
        deleteDeviceShow,
        setDeleteDeviceShow,
        showLogModal,
        setShowLogModal,
        logDevice,
    } = TotalAccessApp({
        data:row
    })

    return (
        <>
            <DividerWithText/>
            <SubZonesDetailsTable
                table={true}
                zoneDetailFatherAndChild={row}
                disabled={true}
                tableId={"tb_rer_subzone_table_"+ row?.id}
                searchId={"txt_rer_search_subzone_" + row?.id}
            />
            <div className='row'>
                <div className='col-md-12 p-0  pt-3'>
                    <DividerWithText/>
                    <Subtitle table={true} name={'access_devices'}/>
                    <CustomTable tableId={tableId +row?.id}
                                 searchId={searchId+row?.id}
                                 thead={thead}
                                 tbody={tbody}
                                 columnActions={false}
                                 withoutHeight={true}

                    />
                </div>
            </div>
            <DeleteModal
                show={deleteDeviceShow}
                onHide={() => setDeleteDeviceShow(false)}
                onClickFn={() => deleteSelectedDevices(selectDeviceForDelete)}
                data={selectDeviceForDelete}
                title_modal={t('delete_devices')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('devices')}
            />
            {showLogModal &&
                <DeviceLogModal
                    show={showLogModal}
                    onHide={() => {
                        setShowLogModal(false);
                    }}
                    data={logDevice}
                />
            }
        </>
    );
};

export default RenderExpandedRow
